/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ConfigRejectedError,
    ConfigRejectedErrorFromJSON,
    ConfigRejectedErrorToJSON,
    RepoConfig,
    RepoConfigFromJSON,
    RepoConfigToJSON,
} from '../models';

export interface DeleteRepoConfigRequest {
    installationId: number;
    repoId: number;
}

export interface GetRepoConfigRequest {
    installationId: number;
    repoId: number;
}

export interface UpdateRepoConfigRequest {
    installationId: number;
    repoId: number;
    repoConfig: RepoConfig;
}

/**
 * ConfigApi - interface
 * 
 * @export
 * @interface ConfigApiInterface
 */
export interface ConfigApiInterface {
    /**
     * 
     * @summary Delete configuration for a repository (resets to default)
     * @param {number} installationId 
     * @param {number} repoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApiInterface
     */
    deleteRepoConfigRaw(requestParameters: DeleteRepoConfigRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete configuration for a repository (resets to default)
     */
    deleteRepoConfig(requestParameters: DeleteRepoConfigRequest, initOverrides?: RequestInit): Promise<void>;

    /**
     * 
     * @summary Get configuration for a repository
     * @param {number} installationId 
     * @param {number} repoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApiInterface
     */
    getRepoConfigRaw(requestParameters: GetRepoConfigRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RepoConfig>>;

    /**
     * Get configuration for a repository
     */
    getRepoConfig(requestParameters: GetRepoConfigRequest, initOverrides?: RequestInit): Promise<RepoConfig>;

    /**
     * 
     * @summary Update configuration for a repository
     * @param {number} installationId 
     * @param {number} repoId 
     * @param {RepoConfig} repoConfig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApiInterface
     */
    updateRepoConfigRaw(requestParameters: UpdateRepoConfigRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RepoConfig>>;

    /**
     * Update configuration for a repository
     */
    updateRepoConfig(requestParameters: UpdateRepoConfigRequest, initOverrides?: RequestInit): Promise<RepoConfig>;

}

/**
 * 
 */
export class ConfigApi extends runtime.BaseAPI implements ConfigApiInterface {

    /**
     * Delete configuration for a repository (resets to default)
     */
    async deleteRepoConfigRaw(requestParameters: DeleteRepoConfigRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling deleteRepoConfig.');
        }

        if (requestParameters.repoId === null || requestParameters.repoId === undefined) {
            throw new runtime.RequiredError('repoId','Required parameter requestParameters.repoId was null or undefined when calling deleteRepoConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/installations/{installationId}/repos/{repoId}/config`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))).replace(`{${"repoId"}}`, encodeURIComponent(String(requestParameters.repoId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete configuration for a repository (resets to default)
     */
    async deleteRepoConfig(requestParameters: DeleteRepoConfigRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteRepoConfigRaw(requestParameters, initOverrides);
    }

    /**
     * Get configuration for a repository
     */
    async getRepoConfigRaw(requestParameters: GetRepoConfigRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RepoConfig>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling getRepoConfig.');
        }

        if (requestParameters.repoId === null || requestParameters.repoId === undefined) {
            throw new runtime.RequiredError('repoId','Required parameter requestParameters.repoId was null or undefined when calling getRepoConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/web/installations/{installationId}/repos/{repoId}/config`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))).replace(`{${"repoId"}}`, encodeURIComponent(String(requestParameters.repoId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RepoConfigFromJSON(jsonValue));
    }

    /**
     * Get configuration for a repository
     */
    async getRepoConfig(requestParameters: GetRepoConfigRequest, initOverrides?: RequestInit): Promise<RepoConfig> {
        const response = await this.getRepoConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update configuration for a repository
     */
    async updateRepoConfigRaw(requestParameters: UpdateRepoConfigRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<RepoConfig>> {
        if (requestParameters.installationId === null || requestParameters.installationId === undefined) {
            throw new runtime.RequiredError('installationId','Required parameter requestParameters.installationId was null or undefined when calling updateRepoConfig.');
        }

        if (requestParameters.repoId === null || requestParameters.repoId === undefined) {
            throw new runtime.RequiredError('repoId','Required parameter requestParameters.repoId was null or undefined when calling updateRepoConfig.');
        }

        if (requestParameters.repoConfig === null || requestParameters.repoConfig === undefined) {
            throw new runtime.RequiredError('repoConfig','Required parameter requestParameters.repoConfig was null or undefined when calling updateRepoConfig.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/web/installations/{installationId}/repos/{repoId}/config`.replace(`{${"installationId"}}`, encodeURIComponent(String(requestParameters.installationId))).replace(`{${"repoId"}}`, encodeURIComponent(String(requestParameters.repoId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RepoConfigToJSON(requestParameters.repoConfig),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RepoConfigFromJSON(jsonValue));
    }

    /**
     * Update configuration for a repository
     */
    async updateRepoConfig(requestParameters: UpdateRepoConfigRequest, initOverrides?: RequestInit): Promise<RepoConfig> {
        const response = await this.updateRepoConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
